/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsModeratorControllerTakeToModerationMutationResponse,
  TelegramProductsModeratorControllerTakeToModerationPathParams,
  TelegramProductsModeratorControllerTakeToModeration400,
  TelegramProductsModeratorControllerTakeToModeration401,
  TelegramProductsModeratorControllerTakeToModeration404,
  TelegramProductsModeratorControllerTakeToModeration409,
} from '../../types/TelegramProductsModeratorControllerTakeToModeration.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramProductsModeratorTakeToModeration } from '../../methods/telegramProductsModeratorTakeToModeration.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramProductsModeratorTakeToModerationMutationKey = () =>
  [{ url: '/api/moderator/telegram/products/take/:id' }] as const;

export type TelegramProductsModeratorTakeToModerationMutationKey = ReturnType<
  typeof telegramProductsModeratorTakeToModerationMutationKey
>;

/**
 * {@link /api/moderator/telegram/products/take/:id}
 */
export function useTelegramProductsModeratorTakeToModeration<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramProductsModeratorControllerTakeToModerationMutationResponse,
      ResponseErrorConfig<
        | TelegramProductsModeratorControllerTakeToModeration400
        | TelegramProductsModeratorControllerTakeToModeration401
        | TelegramProductsModeratorControllerTakeToModeration404
        | TelegramProductsModeratorControllerTakeToModeration409
      >,
      { id: TelegramProductsModeratorControllerTakeToModerationPathParams['id'] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramProductsModeratorTakeToModerationMutationKey();

  return useMutation<
    TelegramProductsModeratorControllerTakeToModerationMutationResponse,
    ResponseErrorConfig<
      | TelegramProductsModeratorControllerTakeToModeration400
      | TelegramProductsModeratorControllerTakeToModeration401
      | TelegramProductsModeratorControllerTakeToModeration404
      | TelegramProductsModeratorControllerTakeToModeration409
    >,
    { id: TelegramProductsModeratorControllerTakeToModerationPathParams['id'] },
    TContext
  >(
    {
      mutationFn: async ({ id }) => {
        return telegramProductsModeratorTakeToModeration(id, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
